// ===========================================
// SCHEMA: RegistrarVEP
// ===========================================
// Schema Zod para el formulario de registrar VEP

import { z } from 'zod'

export const registrarVEPSchema = z.object({
  vep_numero: z.string().min(1, 'El número de VEP es requerido'),
  vep_monto: z.number().min(0, 'El monto no puede ser negativo').max(99999999, 'El monto no puede ser mayor a 99.999.999').nullable().optional(),
  vep_fecha_vencimiento: z.string().nullable().optional(),
})

export type RegistrarVEPFormValues = z.infer<typeof registrarVEPSchema>
